import React from "react";
import { IShoppingCartItem } from "../../models/IShoppingCartModel";
import { Button, Tooltip } from "antd";
import {
  useTranslation,
  WithTranslation,
  withTranslation,
} from "react-i18next";
import QuantityNumber from "../../components/quantityNumber/intex";
import _ from "lodash";
import { DefaultImg } from "../../components/images";
import { DeleteOutlined } from "@ant-design/icons";
import { checkSpecialMattress, localizeRouteKey } from "../../shared/helpers";
import {
  APP_LANGUAGE,
  PROPERTY_TYPE,
  ROUTER_PATH,
  WIDTH_IPAD,
} from "../../common/constant";
import { renderMoreProperty } from "../Checkout/shoppingCartInfo";
import { Link } from "react-router-dom";
interface IShoppingCartItemProps extends WithTranslation {
  item: IShoppingCartItem | any;
  onChangeShoppingCartItem: Function;
  onDeleteShoppingCartItem: Function;
  history: any;
}

const Item = (props: IShoppingCartItemProps) => {
  const { item, onChangeShoppingCartItem, onDeleteShoppingCartItem } = props;
  const { t, i18n } = useTranslation();
  // const [quantity, setQuantity] = React.useState(item.quantity);
  const { innerWidth } = window;

  const handleOnChangeQty = (value: number) => {
    let _item = _.clone(props.item);
    _item.quantity = value;
    if (onChangeShoppingCartItem) {
      onChangeShoppingCartItem(_item);
      // setQuantity(value);
    }
  };

  const handleDelete = () => {
    if (onChangeShoppingCartItem) {
      onDeleteShoppingCartItem(props.item);
    }
  };

  const renderIconRemove = (className: string = "") => {
    return (
      <div className={`sci-item-actions ${className}`}>
        <Tooltip
          placement="topRight"
          title={innerWidth > WIDTH_IPAD ? t("shopping_cart_remove") : ""}
          className="action-cart-wrap">
          <Button
            size={"small"}
            type={"link"}
            className="sci-item-action"
            onClick={() => handleDelete()}>
            <DeleteOutlined style={{ fontSize: "16px", color: "#000" }} />
          </Button>
          <QuantityNumber
            onChange={(value: any) => handleOnChangeQty(value)}
            qty={item.quantity}
            min={1}
            max={100}
          />
        </Tooltip>
      </div>
    );
  };

  const handleClick = () => {
    let product_spec_code = null;
    let product_foam = null;
    const path =
      i18n.language === APP_LANGUAGE.Vietnamese
        ? item.product.slug
        : item.product.slug_en || "";

    if (item.product_property) {
      if (item.product_property[PROPERTY_TYPE.image]) {
        product_spec_code =
          item.product_property[PROPERTY_TYPE.image].value || null;
      }
      if (item.product_property[PROPERTY_TYPE.foam]) {
        product_foam = item.product_property[PROPERTY_TYPE.foam].value || null;
      }
    }
    return {
      pathname:
        localizeRouteKey(ROUTER_PATH.PRODUCT_DETAIL) +
        `/${path}/${item.product.code}${
          product_foam
            ? `?foam=${product_foam}`
            : product_spec_code
            ? `?spec=${product_spec_code}`
            : ""
        }`,
      state: {
        product_id: item.product.cat_id_v2 || item.product._id,
        product_code: item.product.code,
        product_spec_code,
        product_foam,
        path: "",
      },
    };
  };

  return (
    <div className="shopping-cart-item-container">
      <div className="shopping-cart-item-wrapper">
        <div className="product-image-container">
          {item.product.img ? (
            <img src={item.product.img} title={item.product.name} />
          ) : (
            <img src={DefaultImg} title={item.product.name} />
          )}
          {renderIconRemove("sm")}
        </div>
        <div className="product-info-container">
          <div className="product-info-wrapper">
            <div className="product-info-left">
              <Link
                className="product-name sub-content"
                title={item.product.name}
                to={handleClick()}>
                {item.product.name}
              </Link>
              {renderMoreProperty(item.product_property)}
              <div
                className="product-spec sub-content"
                title={item.product?.feature?.spec || item.product?.label}>
                {item.product?.feature?.spec || item.product?.label}
              </div>
              {/* <div className="shopping-item-quantity-wrapper">
                <span className="sub-content">
                  {t("shopping_cart_quantity_title")}:
                </span>
                &nbsp;
                <span className="quantity-item">{quantity}</span>
                // <div className="sci-quantity-wrapper">
                //   <QuantityNumber
                //     onChange={(value: any) => handleOnChangeQty(value)}
                //     qty={item.quantity}
                //     min={1}
                //     max={10}
                //   />
                // </div>
              </div> */}
            </div>
            <div className="product-info-right">
              <div className="product-price-label sub-content">
                {t("shopping_cart_unit_price_title")}:
              </div>
              <div className={"product-sealed-price-wrapper"}>
                <span className="product-price product-discount-price main-content">
                  {item.amount} VND
                </span>
              </div>
              {item.discount_percent &&
                !checkSpecialMattress(item.amount, item.sealed_price) && (
                  <div className={"product-discount-wrapper"}>
                    <del className="product-price product-sealed-price sub-content">
                      {item.sealed_price} VND
                    </del>
                    <span className="product-discount-percent sub-content">
                      {item.discount_percent}
                    </span>
                  </div>
                )}
            </div>
          </div>
        </div>
        <div className="shopping-cart-item-actions-container">
          {renderIconRemove()}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(Item);
